<template>
    <router-view style="min-width: 1200px;"/>
</template>

<script>
export default {
    name: 'App',
    mounted () {
        window.onresize = function () {
            localStorage.setItem('WindowsOnResize', Math.random())
        }
    }
}
</script>

<style type="text/css">
html,
body {
    margin: 0;
    padding: 0;
    font-family: "microsoft yahei", simhei, simsun;
}

#app {
    height: 100%;
}

.el-scrollbar__wrap {
    overflow-x: hidden !important;
}

.el-dialog__body {
    padding: 0 20px;
}

.el-dialog__header {
    border: 1px #EEEEEE solid;
}

.itemForm {
    margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue